class MenuSlider {
    constructor(element) {
        Object.defineProperty(this, "slider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "prevArrow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nextArrow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sliderRef", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.slider = element.querySelector('.menu');
        this.prevArrow = element.querySelector('.prev-arrow') ?? undefined;
        this.nextArrow = element.querySelector('.next-arrow') ?? undefined;
        window.addEventListener('resize', () => {
            this.init();
        });
        this.init();
    }
    init() {
        if (globalThis.matchMedia('(max-width: 767px)').matches) {
            this.initSlider();
        }
        else {
            this.removeSlider();
        }
    }
    initSlider() {
        if (!this.sliderRef && this.slider) {
            const currentMenuItem = jQuery('.program-menu').find('.current-menu-item');
            const slide = currentMenuItem.index();
            this.sliderRef = jQuery(this.slider).slick({
                fade: true,
                prevArrow: this.prevArrow,
                nextArrow: this.nextArrow,
                rows: 0,
                infinite: false,
                initialSlide: slide,
            });
        }
    }
    removeSlider() {
        this.sliderRef?.slick('unslick');
        this.sliderRef = undefined;
    }
}
export default function menuSlider() {
    const menu = document.querySelectorAll('.program-menu');
    for (const element of menu) {
        new MenuSlider(element);
    }
}
